import { makeAutoObservable, runInAction } from 'mobx';

import { client } from 'contexts/ApolloClient/apolloClient';
import { constructDriverInfo } from 'utils/constructDriverInfo';

import { FETCH_CREW_MEMBER } from './gql/getCrewMember';
import { FETCH_CREW_MEMBER_EMPLOYMENT_TYPE } from './gql/getCurrentEmployment';
import { TABS_CONFIG } from './tabsConfig';

class CrewMemberDetailsStore {
	activeTab = TABS_CONFIG.get('timeline').id;

	employeeId = null;

	employeeInfo = null;
	editData = null;
	employmentType = null;
	currentHomeBase = null;

	loading = false;
	error = null;

	editPanelActive = false;

	constructor() {
		makeAutoObservable(this, {}, { autoBind: true });
	}

	setActiveTab(tabId) {
		this.activeTab = tabId;
	}

	async init(crewId) {
		this.setEmployeeId(crewId);
		await this.fetchAll();
	}

	async fetchAll() {
		if (!this.employeeId) return;
		this.loading = true;
		this.error = null;

		try {
			const { data: crewData } = await client.query({
				query: FETCH_CREW_MEMBER,
				variables: { id: this.employeeId },
				fetchPolicy: 'no-cache',
				notifyOnNetworkStatusChange: true,
			});

			const { data: emplData } = await client.query({
				query: FETCH_CREW_MEMBER_EMPLOYMENT_TYPE,
				variables: { id: this.employeeId },
				fetchPolicy: 'no-cache',
				notifyOnNetworkStatusChange: true,
			});

			runInAction(() => {
				if (crewData?.getCrewMember) {
					this.employeeInfo = { ...constructDriverInfo(crewData) };
					this.editData = { ...crewData.getCrewMember };

					if (crewData.getCrewMember.currentHomeBase) {
						this.currentHomeBase = crewData.getCrewMember.currentHomeBase;
					}
					if (crewData.getCrewMember.currentEmploymentType) {
						this.employmentType = crewData.getCrewMember.currentEmploymentType;
					}
				}

				const explicitEmpl = emplData?.getCrewMember?.currentEmploymentType;
				if (explicitEmpl) this.employmentType = explicitEmpl;

				this.loading = false;
			});
		} catch (err) {
			runInAction(() => {
				this.error = err;
				this.loading = false;
			});
		}
	}

	setEmployeeId(id) {
		this.employeeId = id;
	}
	setEmploymentType(employmentType) {
		this.employmentType = employmentType;
	}
	setCurrentHomeBase(currentHomeBase) {
		this.currentHomeBase = currentHomeBase;
	}

	setEditPanelActive(v) {
		this.editPanelActive = Boolean(v);
	}
	togglePanel() {
		this.editPanelActive = !this.editPanelActive;
	}
}

export const crewMemberDetailsStore = new CrewMemberDetailsStore();
